import { EColors } from './types'

const { haiti, topaz, sunsetOrange, greySuit } = EColors

export const textStyles = {
  // App Typography
  hero: {
    value: {
      fontSize: '72px',
      lineHeight: '76px',
      fontWeight: '900',
    },
  },
  'header-bigger': {
    value: {
      fontSize: '48px',
      fontWeight: '900',
      lineHeight: '52px',
    },
  },
  'header-black': {
    value: {
      fontSize: '36px',
      lineHeight: '40px',
      fontWeight: '900',
    },
  },
  'headline-regular': {
    value: {
      fontSize: '17px',
      lineHeight: '24px',
      fontWeight: '400',
    },
  },
  'title-black': {
    value: {
      fontSize: '24px',
      lineHeight: '28px',
      fontWeight: '900',
    },
  },
  'title-semibold': {
    value: {
      fontSize: '24px',
      lineHeight: '28px',
      fontWeight: '600',
    },
  },
  'subtitle-black': {
    value: {
      fontSize: '18px',
      lineHeight: '20px',
      fontWeight: '900',
    },
  },
  'subtitle-semibold': {
    value: {
      fontSize: '18px',
      lineHeight: '20px',
      fontWeight: '600',
    },
  },
  'subtitle-regular': {
    value: {
      fontSize: '18px',
      lineHeight: '20px',
      fontWeight: '400',
    },
  },
  'body-black': {
    value: {
      fontSize: '15px',
      lineHeight: '20px',
      fontWeight: '900',
    },
  },
  'body-semibold': {
    value: {
      fontSize: '15px',
      lineHeight: '20px',
      fontWeight: '600',
    },
  },
  'body-regular': {
    value: {
      fontSize: '15px',
      lineHeight: '20px',
      fontWeight: '400',
    },
  },
  'caption1-black': {
    value: {
      fontSize: '13px',
      lineHeight: '16px',
      fontWeight: '900',
    },
  },
  'caption1-semibold': {
    value: {
      fontSize: '13px',
      lineHeight: '16px',
      fontWeight: '600',
    },
  },
  'caption1-regular': {
    value: {
      fontSize: '13px',
      lineHeight: '16px',
      fontWeight: '400',
    },
  },
  'caption2-black': {
    value: {
      fontSize: '11px',
      lineHeight: '14px',
      fontWeight: '900',
    },
  },
  'caption2-semibold': {
    value: {
      fontSize: '11px',
      lineHeight: '14px',
      fontWeight: '600',
    },
  },
  'caption2-regular': {
    value: {
      fontSize: '11px',
      lineHeight: '14px',
      fontWeight: '400',
    },
  },
  'micro-semibold': {
    value: {
      fontSize: '8px',
      lineHeight: '10px',
      fontWeight: '600',
    },
  },
  'micro-regular': {
    value: {
      fontSize: '8px',
      lineHeight: '10px',
      fontWeight: '400',
    },
  },

  // redesign v2
  'header-h1-v2': {
    value: {
      fontSize: '30px',
      lineHeight: '32px',
      fontWeight: '900',
    },
  },
  'title-black-v2': {
    value: {
      fontSize: '24px',
      lineHeight: '30px',
      fontWeight: '900',
    },
  },
  'header-h2-v2': {
    value: {
      fontSize: '18px',
      lineHeight: '20px',
      fontWeight: '900',
    },
  },
  'body-regular-v2': {
    value: {
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: '400',
    },
  },
  'caption1-regular-v2': {
    value: {
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: '400',
    },
  },
  'caption2-regular-v2': {
    value: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '400',
    },
  },

  // Heading variants
  mainHeader: {
    value: {
      fontSize: '24px',
      fontWeight: 900,
      lineHeight: '28px',
      letterSpacing: '0',
    },
  },
  bannerHeader: {
    value: {
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '20px',
      letterSpacing: '0px',
      textAlign: 'left',
    },
  },
  subHeader: {
    value: {
      fontSize: '15px',
      fontWeight: 900,
      letterSpacing: 0,
      alignSelf: 'center',
      textAlign: 'center',
    },
  },
  articleTitle: {
    value: {
      fontWeight: 900,
      fontSize: '18px',
      lineHeight: '20px',
      marginBottom: '16px',
    },
  },
  subHeaderLarge: {
    value: {
      fontSize: '24px',
      fontWeight: 900,
      letterSpacing: 0,
      margin: '0 auto',
    },
  },
  subHeaderHaiti: {
    value: {
      color: haiti,
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: '900',
      lineHeight: '20px',
    },
  },
  forStickersStockCard: {
    value: {
      color: haiti,
      fontSize: '18px',
      fontWeight: '900',
      lineHeight: '20px',
      marginBottom: '16px',
    },
  },
  glassesInfoPageGlassCard: {
    value: {
      color: haiti,
      fontSize: '24px',
      fontWeight: '900',
      lineHeight: '28px',
      marginBottom: '16px',
    },
  },

  // Legacy component-specific
  checkboxLabel: {
    value: {
      fontSize: '15px',
      lineHeight: '18px',
      color: haiti,
    },
  },
  checkboxCaption: {
    value: {
      fontSize: '13px',
      color: topaz,
    },
  },
  inputCaption: {
    value: {
      fontSize: '13px',
      lineHeight: '16px',
      color: topaz,
    },
  },
  inputCaptionInvalid: {
    value: {
      fontSize: '13px',
      lineHeight: '16px',
      color: sunsetOrange,
    },
  },
  pageCaption: {
    value: {
      fontSize: '24px',
      lineHeight: '28px',
      fontWeight: 900,
      color: haiti,
    },
  },
  sectionCaption: {
    value: {
      fontSize: '19px',
      lineHeight: '22px',
      fontWeight: 900,
      color: haiti,
    },
  },
  boldBlack: {
    value: {
      fontSize: '15px',
      lineHeight: '17px',
      fontWeight: 900,
      color: haiti,
    },
  },
  semiboldBlack: {
    value: {
      fontSize: '15px',
      lineHeight: '17px',
      fontWeight: 600,
      color: haiti,
    },
  },
  regularGray: {
    value: {
      color: greySuit,
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: '19px',
    },
  },
  regularBlack: {
    value: {
      color: haiti,
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: '19px',
    },
  },
  inputPlaceholder: {
    value: {
      color: greySuit,
      fontSize: '15px',
      lineHeight: '18px',
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: '100%',
      textOverflow: 'ellipsis',
    },
  },
  switchCaption: {
    value: {
      fontSize: '13px',
      color: topaz,
    },
  },
  bannerCaption: {
    value: {
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: '16px',
      letterSpacing: '0em',
      color: topaz,
    },
  },
} as const
